import RightSidebar from "../../MainContent/RightSidebar/RightSidebar";
import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee";
import Prezident_va_maorif from "./Prezident_va_maorif";

const Prezident = () => {
    return (


        <div class="container">
            <div class="row g-5">
                <div class="col-md-12 ">
                    <div className="pb-4">
                        <Search />
                    </div>
                    {/* --------------------------------------------- PAGINATION------------------------------------- */}
                    <Prezident_va_maorif itemsPerPage={8} />
                </div>

                <Marquee />
                {/* -----------------------------------------------   RIGHT SIDEBAR------------------------------------- */}
                {/* <div class="col-md-3 col-lg-4 col-xl-4 pt-5">
                    <div class="position-sticky" >
                        <RightSidebar />
                    </div>
                </div> */}
            </div>
        </div>

        // <div>
        //     <div className="container mt-5">

        //     </div>
        // </div>
    )
}

export default Prezident;